import {PhonesComponent} from '../phones/phones.component';
import {ISpecialization, SpecializationAction, SpecializationState} from '../../models/specializations';
import {Logger} from '../../class/helper/logger.class';
import {cloneDeep} from 'lodash';
import {ClinicState, IClinic} from '../../models/clinic';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {timeZonesData} from '../../config/data/time-zones/time-zones.data';
import {IExpert} from '../../models/expert';
import {GenderEnum} from '../../models/user';
import {AddressSectionComponent} from '../address-section/address-section.component';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {Store} from '@ngxs/store';
import {ClinicBranchState, IClinicBranch} from '../../models/clinic-branch';
import {firstValueFrom, Observable} from 'rxjs';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-modal-create-expert',
  templateUrl: './modal-create-expert.component.html',
  styleUrls: ['./modal-create-expert.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCreateExpertComponent implements OnInit, OnChanges {
  // tslint:disable:no-redundant-jsdoc
  @Input() notClosable: boolean;
  @Input() completeData: boolean;
  @Input() expert: IExpert;
  // Modal actions
  @Input() isVisibleModal: boolean;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  genderEnum = GenderEnum;
  timeZones: string[];
  clinicBranchIdSelected: string;
  helperValidationField: HelperValidationField;
  welcomeMessage: boolean;
  @ViewChild('expertForm') expertForm: NgForm;
  @ViewChild(PhonesComponent) phonesComponent: PhonesComponent;
  @ViewChild(AddressSectionComponent) addressSectionComponent: AddressSectionComponent;
  clinicBranches$: Observable<IClinicBranch[]> = this.store.select<IClinicBranch[]>(ClinicBranchState.getClinicBranchesByClinicSelected);
  specializations$: Observable<ISpecialization[]> = this.store.select<ISpecialization[]>(SpecializationState.getSpecializations);

  platformConfig = PLATFORM_CONFIG;
  constructor(
    public utilitiesServices: UtilitiesService,
    private store: Store
  ) { }

  /**
   * Inicializa las propiedades necesarias.
   */
  ngOnInit(): void {
    this.initValuesHttp();
    this.verifyExistsExpert();
    this.helperValidationField = new HelperValidationField();
    this.timeZones = timeZonesData.nameTimeZones();
  }

  async initValuesHttp(): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new SpecializationAction.Get())));
    } catch (e) {
      Logger.log(e);
    }
  }

  /**
   * Se emite al componente padre que se cerró el modal
   * @param emit
   */
  onEmitCloseModal(emit: boolean): void {
    this.closeModal.emit(emit);
  }

  /**
   * Stecta cambios para verificar si el experto ya existe.
   * @param changes
   */
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.isVisibleModal?.currentValue === false) {
      this.verifyExistsExpert();
    }
  }

  /**
   * Abre el modal para completar la información del experto.
   */
  async onViewForm(): Promise<void> {
    try {
      const clinic: IClinic = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicState.getClinicSelected))));
      if (clinic && this.expert.user) {
        this.expert.user.address = cloneDeep(clinic.address);
        this.expert.user.phones = cloneDeep(clinic.phones);
      }
      this.welcomeMessage = true;
    } catch (e) {
      console.log(e);
    }

  }

  /**
   * Touch all forms
   */
  formMarkAllAsTouched(): void {
    this.expertForm.form.markAllAsTouched();
    this.addressSectionComponent?.formAddress?.form?.markAllAsTouched();
    this.phonesComponent.isValid();
  }

  /**
   * Check that forms expertForm, phoneSectionComponent and addressSectionComponent are valid
   * @return boolean
   */
  areValidForms(): boolean {
    return (this.expertForm.valid &&
      this.addressSectionComponent?.formAddress?.valid && this.phonesComponent.isValid());
  }

  /**
   * Get clinicBranch values
   * @return IClinicBranch
   * @note need to add the clinicId property externally
   */
  getValue(): any {
    return {
      ...this.expertForm.form.value,
      clinicBranchId: this.clinicBranchIdSelected,
      address: this.addressSectionComponent?.formAddress?.value,
      phones: this.phonesComponent.getRawValue(),
    };
  }

  /**
   * Verifica si existe la propiedad expert o sino agrega propiedades iniciales
   */
  verifyExistsExpert(): void {
    this.expert = cloneDeep(this.expert ?? {
      clinicId: '',
      publicInformation: '',
      specializationId: '',
      userId: '',
      user: {
        email: '',
        name: '',
        lastname: '',
        profileImageURL: '',
        password: '',
        address: {
          country: '',
          reference: '',
          state: '',
          street: '',
          cp: '',
          suburb: '',
          city: ''
        },
        timeZone: this.utilitiesServices.getTimeZoneBrowser(),
        phones: [],
        birthday: null,
        gender: null
      }
    });
  }

  resetForm(): void {
    this.expert = cloneDeep({
      clinicId: '',
      publicInformation: '',
      specializationId: '',
      userId: '',
      user: {
        email: '',
        name: '',
        lastname: '',
        profileImageURL: '',
        password: '',
        address: {
          country: '',
          reference: '',
          state: '',
          street: '',
          cp: '',
          suburb: '',
          city: ''
        },
        timeZone: this.utilitiesServices.getTimeZoneBrowser(),
        phones: [],
        birthday: null,
        gender: null
      }
    });
  }
}
